import styled from 'styled-components';
export const StyledTooltipContainer = styled.div `
  position: relative;
`;
